import { Container } from "react-bootstrap";

const HowItWork = () => {
  return (
    <div className="how-it-work">
      <Container>
        <img src="assets/howitwork.png" className="img-fluid" alt="" />
      </Container>
    </div>
  );
};
export default HowItWork;
